import React, { useState } from "react";
import { Form, Typography, Layout } from "antd";
import styles from "./index.css";
import RegisterForm from "./components/RegisterForm";

const RegisterPage = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = (values) => {
        setLoading(true);
        // console.log("Login values:", values);
        // 这里添加登录逻辑
        setTimeout(() => {
            setLoading(false);
        }, 1500);
    };

    return (
        <div className={styles.welcome}>
            <div flex="cross:center" className={styles.loginHeader}>
                <img
                    alt=""
                    src={require("@/assets/yz_logo.png")}
                    style={{
                        height: "45px",
                        marginRight: "10px",
                    }}
                />
                {/* <img
                    alt=""
                    src={require("@/assets/xiaozhi-ai.png")}
                    style={{ width: "auto", height: "18px" }}
                /> */}
            </div>
            <div className={styles.loginPerson}>
                <img src={require("@/assets/login/login-person.png")} />
            </div>
            <div className={styles.loginBox}>
                <div
                    flex="cross:center"
                    style={{ gap: 20 }}
                    className={styles.loginBoxTop}
                >
                    <img
                        src={require("@/assets/login/hi.png")}
                        style={{ width: "34px", height: "34px" }}
                    />
                    <div className={styles.loginText}>注册</div>
                    <div className={styles.loginWelcome}>
                        WELCOME TO REGISTER
                    </div>
                </div>
                <RegisterForm />
            </div>
        </div>
    );
};

export default RegisterPage;
